import { Component, OnInit } from '@angular/core';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'app-preference-update',
  templateUrl: './preference-update.component.html',
  styleUrls: ['./preference-update.component.scss']
})
export class PreferenceUpdateComponent implements OnInit {

  constructor(private fuseSplashScreenService: FuseSplashScreenService) { }

  ngOnInit() {
    this.fuseSplashScreenService.hide();
  }

}
